import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, getFormMeta, change } from 'redux-form';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import _ from 'lodash';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';
import TextField from '../../../shared-components/TextField/TextField';
import {FORM_ID} from '../../../framework/App/AppConstants';
import BubbleToolTip from '../../../shared-components/BubbleToolTip/BubbleToolTip';
import { isNonNumeric, normalizeSelfReportedIncome, isValidAnnualIncome } from './SelfReportedIncomeGroupUtils';
import './SelfReportedIncomeGroup.less';

const LOCALE_PREFIX = 'US/components/SelfReportedIncomeGroup/SelfReportedIncomeGroup';

export class SelfReportedIncomeGroup extends Component {
    static propTypes = {
        isSelfReportedIncomeActive: PropTypes.bool.isRequired,
        isSelfReportedIncomeEmpty: PropTypes.bool.isRequired,
        shouldShowWisconsinMessage: PropTypes.bool.isRequired,
        addCurrencySymbolOnFocus: PropTypes.func.isRequired,
        intl: intlShape.isRequired
    };

    formatIncome = (value, name) => {
        const { isSelfReportedIncomeActive } = this.props;
        if (!isSelfReportedIncomeActive && value === '$ ') {
            value = '';
        }
        return value;
    };

    normalizeIncome = (value, previousValue) => {
        const { isSelfReportedIncomeActive } = this.props;
        return normalizeSelfReportedIncome(value, isSelfReportedIncomeActive);
    };

    fieldOnFocus = (event) => {
        const { isSelfReportedIncomeEmpty, addCurrencySymbolOnFocus } = this.props;
        if (isSelfReportedIncomeEmpty) {
            addCurrencySymbolOnFocus();
        }
    };

    render() {
        const { intl, isSelfReportedIncomeActive, shouldShowWisconsinMessage } = this.props;
        const label = intl.formatMessage({id: `${LOCALE_PREFIX}.self-reported-income-tax-label`});
        const toolTipContent = (
            <div>
                <div>{intl.formatMessage({id: `${LOCALE_PREFIX}.self-reported-income-tooltip`})}</div>
                {shouldShowWisconsinMessage && (
                    <div>
                        <span className="wisconsin-tooltip-alert">
                            {intl.formatMessage({id: `${LOCALE_PREFIX}.self-reported-income-tooltip-wisconsin-alert`})}&nbsp;
                        </span>
                        {intl.formatMessage({id: `${LOCALE_PREFIX}.self-reported-income-tooltip-wisconsin`})}
                    </div>
                )}
            </div>
        );

        return (
            <div className={'SelfReportedIncomeGroup'}>
                {isSelfReportedIncomeActive && (
                    <BubbleToolTip
                        contents={toolTipContent}
                        id={'selfReportedIncomeTooltip'}
                    />
                )}

                <Field
                    id="selfReportedIncome"
                    name="selfReportedIncome"
                    component={TextField}
                    maxLength="11"
                    autoComplete="disabled"
                    autoCorrect="off"
                    autoCapitalize="off"
                    arialabel={label}
                    ariadescribedby="selfReportedIncomeTooltip"
                    label={label}
                    type="tel"
                    validate={[
                        isEmpty(),
                        isNonNumeric(),
                        isValidAnnualIncome()
                    ]}
                    normalize={this.normalizeIncome}
                    format={this.formatIncome}
                    onFocus={this.fieldOnFocus}
                />
            </div>
        );
    }
}

export const mapDispatchToProps = dispatch => ({
    addCurrencySymbolOnFocus: () => {
        dispatch(change(FORM_ID, 'selfReportedIncome', '$ '));
    }
});

export const mapStateToProps = state => ({
    // Show Tooltip when the SRI field has focus
    isSelfReportedIncomeActive: _.get(getFormMeta(FORM_ID)(state), 'selfReportedIncome.active', false),
    isSelfReportedIncomeEmpty: (_.get(state, `form.${FORM_ID}.values.selfReportedIncome`, '') === ''),
    shouldShowWisconsinMessage: (_.get(state, `form.${FORM_ID}.values.state`) === 'WI')
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SelfReportedIncomeGroup));
